var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head_wrap navh"},[_c('div',{staticClass:"head_inner"},[_c('div',{staticClass:"head_l"},[_c('img',{staticClass:"logo ml2",attrs:{"src":require("@/assets/imgs/font_logo_new.png")},on:{"click":_vm.backhome}})]),_c('div',{staticClass:"head_r"},[_vm._v(" 新手指南 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }